import React, { createContext, useState } from 'react';
import { TICKET_PAGINATION } from '../../shared/utils/constants';
import { cardListPageSize, isPhoneWidth } from '../../shared/utils/phonePaging';

export interface Props {
  children: React.ReactNode;
} 

export interface ListContextType {
  listStates: ListStatesType;
  setListStates: React.Dispatch<React.SetStateAction<ListStatesType>>;
}

export const ListContext = createContext({} as ListContextType);
const ListProvider = ListContext.Provider;

const ListContextProvider = ({ children }: Props) => {
  const [listStates, setListStates] = useState<ListStatesType>({
    isTicketsFetching: true,
    countTickets: 0,
    tickets: [],
    currentPage: 1,
    // Every fetch of the ticket list falls back to this count, so a phone's first load uses its card page size too.
    countPerPage: cardListPageSize(isPhoneWidth(window.innerWidth), TICKET_PAGINATION.ITEM_PER_PAGE()),
    errorDuringFetch: false
  });

  return (
    <>
      <ListProvider value={{ listStates, setListStates }}>
        {children}
      </ListProvider>
    </>
  );
};

export default ListContextProvider;
